import { FiatVolumes } from '@/state/fiat/fiatTypes';
import { AxiosResponse } from 'axios';
import axiosInstance, { API_ROUTES } from '../lib/http/httpRequest';

export const getFiatSummaryApi = (): Promise<AxiosResponse<FiatVolumes>> =>
    axiosInstance.get(API_ROUTES.FIAT_SUMMARY);
